var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Downshift from 'downshift';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
function renderInput(inputProps) {
    var InputProps = inputProps.InputProps, disabled = inputProps.disabled, classes = inputProps.classes, ref = inputProps.ref, other = __rest(inputProps, ["InputProps", "disabled", "classes", "ref"]);
    return (React.createElement(TextField, __assign({ InputProps: __assign({ inputRef: ref, classes: {
                root: classes.inputRoot,
            } }, InputProps), disabled: disabled }, other)));
}
function renderSuggestion(_a) {
    var suggestion = _a.suggestion, index = _a.index, itemProps = _a.itemProps, highlightedIndex = _a.highlightedIndex, selectedItem = _a.selectedItem;
    var isHighlighted = highlightedIndex === index;
    var isSelected = (selectedItem || '').indexOf(suggestion.label) > -1;
    return (React.createElement(MenuItem, __assign({}, itemProps, { id: "auto-complete-" + selectedItem.split(' ').join('-') + "-" + highlightedIndex + "-option", key: suggestion.label, selected: isHighlighted, name: suggestion.label, component: "div", style: {
            fontWeight: isSelected ? 500 : 400,
        } }), suggestion.label));
}
function getSuggestions(inputValue, suggestions, showAll) {
    var count = 0;
    return suggestions.filter(function (suggestion) {
        var keep = (!inputValue || suggestion.label.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1) && (showAll || count < 5);
        if (keep) {
            count += 1;
        }
        return keep;
    });
}
var styles = function (theme) { return ({
    root: {
        flexGrow: 1,
    },
    container: {
        flexGrow: 1,
        position: 'relative',
    },
    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
        maxHeight: 350,
        overflow: 'scroll',
    },
    inputRoot: {
        flexWrap: 'wrap',
    },
}); };
function IntegrationDownshift(props) {
    var classes = props.classes, input = props.input, placeholder = props.placeholder, suggestions = props.suggestions, disabled = props.disabled, showAll = props.showAll, other = __rest(props, ["classes", "input", "placeholder", "suggestions", "disabled", "showAll"]);
    return (React.createElement("div", { className: classes.root },
        React.createElement(Downshift, __assign({}, input, { onInputValueChange: function (inputValue) {
                input.onChange(inputValue);
            }, selectedItem: input.value }), function (_a) {
            var getInputProps = _a.getInputProps, getItemProps = _a.getItemProps, isOpen = _a.isOpen, inputValue = _a.inputValue, selectedItem = _a.selectedItem, highlightedIndex = _a.highlightedIndex;
            return (React.createElement("div", { className: classes.container },
                renderInput({
                    fullWidth: true,
                    classes: classes,
                    disabled: disabled,
                    InputProps: getInputProps(__assign({ placeholder: placeholder, id: 'integration-downshift-simple', error: other.error }, input)),
                    error: other.error,
                }),
                isOpen ? (React.createElement(Paper, { className: classes.paper, square: true }, getSuggestions(inputValue, suggestions, showAll).map(function (suggestion, index) {
                    return renderSuggestion({
                        suggestion: suggestion,
                        index: index,
                        itemProps: getItemProps({ item: suggestion.label }),
                        highlightedIndex: highlightedIndex,
                        selectedItem: selectedItem,
                    });
                }))) : null));
        })));
}
// @ts-ignore
export default withStyles(styles)(IntegrationDownshift);



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/Autocomplete.tsx
// module id = 834
// module chunks = 81